<template>
  <!-- 对话框 -->
  <el-dialog :visible.sync="show" width="80%" :before-close="closeDialog">

    <div style="max-height: 50vh ;overflow-y: auto; display: flex;justify-content: space-around;">
      <div style=" width: 50%; max-width: 50vh;overflow-y: auto;">
        <div>
          <h4>司机端</h4>

          <div class="order-model">
            <h5 style="text-indent: 10px;margin: 10px 0;">普通模式:</h5>

            <el-button class="text-btn" type="text" v-if="item.partner_mode.val == 0 && item.wait_mode.val == 0" v-for="(item, index) in driver"
              @click="toDetails(item.order_mode.order_mode_code)">
              {{ item.name }}
              <i class="el-icon-thumb"></i>
            </el-button>

          </div>

          <div class="order-model">
            <h5 style="text-indent: 10px;margin: 10px 0;">自创单模式:</h5>

            <el-button class="text-btn" type="text" v-if="item.wait_mode.val == 1" v-for="(item, index) in driver"
              @click="toDetails(item.order_mode.order_mode_code)">
              {{ item.name }}
              <i class="el-icon-thumb"></i>
            </el-button>

          </div>

          <div class="order-model">
            <h5 style="text-indent: 10px;margin: 10px 0;">合作模式:</h5>

            <el-button class="text-btn" type="text" v-if="item.partner_mode.val == 1" v-for="(item, index) in driver"
              @click="toDetails(item.order_mode.order_mode_code)">
              {{ item.name }}
              <i class="el-icon-thumb"></i>
            </el-button>
          </div>
        </div>



        <div>
          <h4>乘客端</h4>
          <div class="order-model">
            <h5 style="text-indent: 10px;margin: 10px 0;">普通模式:</h5>

            <el-button class="text-btn" type="text" v-if="item.partner_mode.val == 0 && item.wait_mode.val == 0" v-for="(item, index) in consumer"
              @click="toDetails(item.order_mode.order_mode_code)">
              {{ item.name }}
              <i class="el-icon-thumb"></i>
            </el-button>
          </div>

          <div class="order-model">
            <h5 style="text-indent: 10px;margin: 10px 0;">自创单模式:</h5>

            <el-button class="text-btn" type="text" v-if="item.wait_mode.val == 1" v-for="(item, index) in consumer"
              @click="toDetails(item.order_mode.order_mode_code)">
              {{ item.name }}
              <i class="el-icon-thumb"></i>
            </el-button>
          </div>

          <div class="order-model">
            <h5 style="text-indent: 10px;margin: 10px 0;">合作模式:</h5>

            <el-button class="text-btn" type="text" v-if="item.partner_mode.val == 1" v-for="(item, index) in consumer"
              @click="toDetails(item.order_mode.order_mode_code)">
              {{ item.name }}
              <i class="el-icon-thumb"></i>
            </el-button>
          </div>
        </div>



        <div>
          <h4>后台</h4>
          <div class="order-model">
            <h5 style="text-indent: 10px;margin: 10px 0;">普通模式:</h5>

            <el-button class="text-btn" type="text" v-if="item.partner_mode.val == 0 && item.wait_mode.val == 0" v-for="(item, index) in admin"
              @click="toDetails(item.order_mode.order_mode_code)">
              {{ item.name }}
              <i class="el-icon-thumb"></i>
            </el-button>
          </div>

          <div class="order-model">
            <h5 style="text-indent: 10px;margin: 10px 0;">自创单模式:</h5>

            <el-button class="text-btn" type="text" v-if="item.wait_mode.val == 1" v-for="(item, index) in admin"
              @click="toDetails(item.order_mode.order_mode_code)">
              {{ item.name }}
              <i class="el-icon-thumb"></i>
            </el-button>
          </div>

          <div class="order-model">
            <h5 style="text-indent: 10px;margin: 10px 0;">合作模式:</h5>

            <el-button class="text-btn" type="text"  v-if="item.partner_mode.val == 1" v-for="(item, index) in admin"
              @click="toDetails(item.order_mode.order_mode_code)">
              {{ item.name }}
              <i class="el-icon-thumb"></i>
            </el-button>
          </div>
        </div>


      </div>
      <div style="width: 50%;">

        <iframeModel :isShow="iframe_show" :param="iframe_param" :iframe_url="iframe_url"></iframeModel>

      </div>
    </div>

    <!-- 对话框底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">返回</el-button>
    </span>

  </el-dialog>
</template>

<script>
  var _this, district, map;
  import axios from 'axios'; // AJAX封装类
  import {
    config
  } from '../../utils/config.js'; //配置
  import iframeModel from './iframe.vue';
  export default {
    components: {
      iframeModel
    },
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;


        _this.$post(
            "/order/getOrderModePortLists", {
              city_code: _this.data
            }
          )
          .then(res => {

            _this.admin = res.data.admin;
            _this.consumer = res.data.consumer;
            _this.driver = res.data.driver;


          })


        _this.iframe_url = config.h5;
      },
    },
    data() {
      return {


        show: false,

        admin: [],
        consumer: [],
        driver: [],

        iframe_show: false,
        iframe_url: '',
        iframe_param: '',

      };
    },
    created() {

      _this = this;

    },
    methods: {

      toDetails(code) {

        _this.iframe_param = code;

        if (_this.iframe_show) {
          _this.iframe_show = false;
        }
        setTimeout(() => {
          _this.iframe_show = true;
        }, 100);


      },


      closeDialog() {

        _this.show = false;
        _this.iframe_show = false;

        _this.admin = [];
        _this.consumer = [];
        _this.driver = [];

      },



    }
  };
</script>

<style scoped>
  #container_add {
    height: 90%;
    width: 65%;
    float: left;
  }

  .order-model{
    margin: 20px 0;
  }


  .mode-data {

    margin: 20px 0;
  }

  iframe {
    width: 100%;
    border: medium none;
    height: 100%;
  }

  h4 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
  }

  h5 {
    font-size: 20px;
    font-weight: normal;
  }

  .text-btn {
    font-size: 18px;
    margin-left: 20px;
    padding: 5px;
    display: block;
  }
</style>